import React, { Component } from 'react';
import './EditFloatWindow.css'
import { withStyles } from '@material-ui/core/styles';
import ImageIcon from '@material-ui/icons/Image';
import NotesIcon from '@material-ui/icons/Notes';
import Button from '@material-ui/core/Button';
import ColorPickerCell from './ColorPickerCell'
//import ImageEditWindow from './ImageEditWindow'
import EditCompositionList from './EditCompositionList'


const wStyles = theme => ({
    textLink:{
        height:40,
        color:"white",
        fontFamily:"Microsoft JhengHei",
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        backgroundColor:"#2783c4",
        textAlign:"center",
        fontSize:20,
        lineHeight:"30px",
        margin:5,
        '&:hover':{
            color:"black",
        },
    },
})


class EditFloatWindow extends Component {
    constructor(props){
        super(props)
        this.state={
            position:{
                x:300,
                y:400,
            },
            refPos:{
                x:0,
                y:0
            },
            divSize:{
                width:220,
                height:300,
            },
            refDivSize:{
                width:0,
                height:0
            },
            selectedTab:1,
            containerExtending:false,
            containerDragging:false,
        }
        this.editFloatWindowRef = React.createRef()
    }

   

    componentDidUpdate(prevProps, prevState) {
        
        //console.log("con 0")
        
        if(this.state.containerExtending === false && this.state.containerDragging === true)
        {
            if(prevProps.mousePos !== this.props.mousePos)
            {
                //console.log("con 1")
                this.setNewContainerPosition()
            } 
        }
        else if(this.state.containerExtending === true && this.state.containerDragging === false)
        {
            if(prevProps.mousePos !== this.props.mousePos)
            {
                //console.log("con 2")
                this.setNewContainerSize()
            } 
        }
        else if(prevProps.size !== this.props.size)
        {
            //console.log("con 3")
        }

        if(prevProps.editToken !== this.props.editToken)
        {
            //console.log("con 4")
            this.setState({
                selectedTab:2
            })
        }
    }

    setNewContainerPosition() {
        //let rect = this.editFloatWindowRef.current.getBoundingClientRect()
        //let rectLeft = rect.left
        //let rectTop= rect.top

        let containerX = this.props.mousePos.x-this.state.refPos.x
        let containerY = this.props.mousePos.y-this.state.refPos.y

        //let containerX = rect.left-this.state.refPos.x
        //let containerY = rect.top-this.state.refPos.y

        let newPos = {
            x:containerX,
            y:containerY
        }
        //let newRect = {
        //    x:rectLeft,
        //    y:rectTop
        //}
        this.setState({
            //trans:newPos
            position:newPos,
            //rect:newRect
        })
    }

    setNewContainerSize=()=>{

        let width = this.state.refDivSize.width+(this.props.mousePos.x-this.state.refPos.x)
        let height = this.state.refDivSize.height+(this.props.mousePos.y-this.state.refPos.y)

        if(width<220)
        {
            width = 220
        }

        if(height<300)
        {
            height = 300
        }

        let newSize = {
            width:width,
            height:height
        }
   
        this.setState({
            divSize:newSize
        })
       
    }

    onClickAddImage=()=>{
        this.props.addImageContainer()
    }

    onClickAddText=()=>{
        this.props.addTextContainer()
    }

    

    extendAreaMouseDown=(e)=>{
        // console.log('extendAreaMouseDown')
        e.stopPropagation()
        this.setState({
            containerExtending:true,
            refPos:{
                //x:e.clientX-this.props.offset.x,
                //y:e.clientY-this.props.offset.y
                x:e.clientX,
                y:e.clientY
            },
            refDivSize:this.state.divSize
        })   

        let msg ={
            conID:this.props.conID,
            //unitID:this.props.showingUnitID,
            //zIndex:this.props.zIndex,
            containerExtending:true,
            //subView:this.getSubView()
        }
        this.props.containerExtending(msg)
    }

    extendAreaMouseUp=(e)=>{
        e.stopPropagation()
        // console.log('extendAreaMouseUp')
        
        this.setState({
            containerExtending:false,
            
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            conID:this.props.conID,
            //unitID:this.props.showingUnitID,
            //zIndex:this.props.zIndex,
            containerExtending:false,
            //subView:'nonSubView'
        }
        
        this.props.containerExtending(msg)

    }

 
    headerMouseDown=(e)=>{   
        e.stopPropagation()
        e.preventDefault()
        //console.log('ControllerUnitContainer headerMouseDown')
    
        this.setState({
            containerDragging:true,
            refPos:{
                x:e.clientX-this.state.position.x,
                y:e.clientY-this.state.position.y
                //x:e.clientX,
                //y:e.clientY
            }
        })   

        let msg ={
            conID:this.props.conID,
            //unitID:this.props.showingUnitID,
            //zIndex:this.props.zIndex,
            containerDragging:true,
        }
        this.props.containerDragging(msg)
    }

    headerMouseUp=(e)=>{
        e.stopPropagation()
        // let newPos = {
        //     x : this.state.position.x+this.state.trans.x,
        //     y : this.state.position.y+this.state.trans.y
        // }
        this.setState({
            containerDragging:false,
            // position:newPos,
            refPos:{
                x:0,
                y:0
            },
        })  

        let msg ={
            conID:this.props.conID,
            //unitID:this.props.showingUnitID,
            //zIndex:this.props.zIndex,
            containerDragging:false,
            position:this.state.position
        }
        this.props.containerDragging(msg)
    }

    tabOnClick=(id)=>{
        //console.log("tabOnClick...")
        //console.log(id)
        if(this.state.selectedTab !== id)
        {
            this.setState({
                selectedTab:id
            })
        }
    }

    checkTabSelected=(id)=>{
        if(id===this.state.selectedTab)
        {
            return "selectedHeaderTab"
        }
        else
        {
            return "headerTab"
        }
    }

    loadCompositionType = () =>{
        //console.log("load Composition Type...")
        let output = ""
        this.props.compositionContainers.forEach(container=>{
            if(container.conID === this.props.editingContainer)
            {
                output = container.type
            }
        })

        return output
    }

    changeTitle = (e) => {
        let output = this.props.editingCompositionInfo
        output.title = e.target.value
        
        this.props.getCompositionChangedInfo(output)
    }

    changeBorderStyle = (e) =>{
        let output = this.props.editingCompositionInfo
        output.commonAttributes.border.style = e.target.value
        
        this.props.getCompositionChangedInfo(output)  
    }

    changeBorderWidth = (e) =>{
        let output = this.props.editingCompositionInfo
        output.commonAttributes.border.width = e.target.value
        
        this.props.getCompositionChangedInfo(output)  
    }

    changeBorderColor = (msg) =>{
        let output = this.props.editingCompositionInfo
        output.commonAttributes.border.color = msg
        
        this.props.getCompositionChangedInfo(output)  
    }

    changeWidth = (e) => {
        let output = this.props.editingCompositionInfo
        output.width = Number(e.target.value)
        
        this.props.getCompositionChangedInfo(output)
    }

    changeHeight = (e) => {
        let output = this.props.editingCompositionInfo
        output.height = Number(e.target.value)
        
        this.props.getCompositionChangedInfo(output)
    }

    changeX = (e) => {
        let output = this.props.editingCompositionInfo
        output.x = Number(e.target.value)
        
        this.props.getCompositionChangedInfo(output)
    }

    changeY = (e) => {
        let output = this.props.editingCompositionInfo
        output.y = Number(e.target.value)
        
        this.props.getCompositionChangedInfo(output)
    }

    changeZ = (e) => {
        let output = this.props.editingCompositionInfo
        output.zIndex = Number(e.target.value)
        
        this.props.getCompositionChangedInfo(output)
    }

    changeImageAdjust=(e,type)=>{
        let output = this.props.editingCompositionInfo
        let value = 0
        switch(type){
            case 'contrast':       
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 200)
                {
                    value = 200
                }
                else
                {
                    value = Number(e.target.value)
                }          
                output.imageAttributes.imageAdjust.contrast = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'hue':    
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 360)
                {
                    value = 360
                }
                else
                {
                    value = Number(e.target.value)
                }        
                output.imageAttributes.imageAdjust.hue = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'brightness':
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 200)
                {
                    value = 200
                }
                else
                {
                    value = Number(e.target.value)
                }         
                output.imageAttributes.imageAdjust.brightness = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'saturate':
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 100)
                {
                    value = 100
                }
                else
                {
                    value = Number(e.target.value)
                }             
                output.imageAttributes.imageAdjust.saturate = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'sepia':
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 100)
                {
                    value = 100
                }
                else
                {
                    value = Number(e.target.value)
                }   
                output.imageAttributes.imageAdjust.sepia = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'invert': 
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 100)
                {
                    value = 100
                }
                else
                {
                    value = Number(e.target.value)
                }       
                output.imageAttributes.imageAdjust.invert = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'blur':  
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 10)
                {
                    value = 10
                }
                else
                {
                    value = Number(e.target.value)
                }           
                output.imageAttributes.imageAdjust.blur = value
                this.props.getCompositionChangedInfo(output)           
            break;
            case 'opacity':
                if(e.target.value<0)
                {
                    value = 0
                }
                else if(e.target.value> 100)
                {
                    value = 100
                }
                else
                {
                    value = Number(e.target.value)
                }  
                output.imageAttributes.imageAdjust.opacity = value
                this.props.getCompositionChangedInfo(output)           
            break;
            default:
            break
        }
    }

    changeTextBackgroundColor=(msg)=>{
        console.log("EditFloatWindow changeTextBackgroundColor...")
        console.log(msg)
        let output = this.props.editingCompositionInfo
        output.textAttributes.background.color = msg
        this.props.getCompositionChangedInfo(output)
    }

    changeTextBackgroundOpacity=(e)=>{
        let output = this.props.editingCompositionInfo
        output.textAttributes.background.opacity = e.target.value
        this.props.getCompositionChangedInfo(output)
    }

    changeTextFontColor=(msg)=>{
        let output = this.props.editingCompositionInfo
        output.textAttributes.font.color = msg
        this.props.getCompositionChangedInfo(output)
    }

    changeTextFontSize=(e)=>{
        let output = this.props.editingCompositionInfo
        output.textAttributes.font.size = e.target.value
        this.props.getCompositionChangedInfo(output)
    }

    changeTextFontCFamily=(e)=>{
        let output = this.props.editingCompositionInfo
        output.textAttributes.font.cFamily = e.target.value
        this.props.getCompositionChangedInfo(output)
    }

    changeTextFontEFamily=(e)=>{
        let output = this.props.editingCompositionInfo
        output.textAttributes.font.eFamily = e.target.value
        this.props.getCompositionChangedInfo(output)
    }

    

    getEditingCompositionID=(msg)=>{
        this.props.getEditingCompositionID(msg)
    }

    changeSelectedTab=(msg)=>{
        this.setState({
            selectedTab:2
        })
    }

    getContextMenu=(msg)=>{
        this.props.getContextMenu(msg)
    }

    createContainer=()=>{
        const {classes} = this.props;

        let basicFunctionArea = {
            overflow:"auto"
        }

        let addContainerButtonArea = {
            display: 'flex',
            flexDirection: 'column',
            borderBottom:"1px solid black",
        }

        let attributesArea = {
            display: 'flex',
            flexDirection: 'column',
            overflow:'auto',
        }

        let groupTitle = {
            textAlign:"center",
            fontFamily: "Microsoft JhengHei",
            border:"1px solid black",
        }

        let rowArea = {
            display: 'flex',
        }

        let rowTitle = {
            width:"40%",
            border:"1px solid black",
            fontFamily: "Microsoft JhengHei",
        }

        let rowValue = {
            width:"60%",
            border:"1px solid black",
        }

        let rowValueDisbale = {
            width:"60%",
            border:"1px solid black",
            pointerEvents:"none"
        }

        let classWithDisable = {
            pointerEvents:"none"
        }
  
        if(this.state.selectedTab === 1)
        {
            return(
                <div style={basicFunctionArea}>
                    <div style={addContainerButtonArea}>
                        <Button className={classes.textLink} startIcon={<ImageIcon />} onClick={this.onClickAddImage}>
                            新增圖片區塊
                        </Button> 
                        <Button className={classes.textLink} startIcon={<NotesIcon />} onClick={this.onClickAddText}>
                            新增文字區塊
                        </Button>
                    </div>
                    <EditCompositionList editingCompositionID={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.conID : null} compositionContainers={this.props.compositionContainers} getEditingCompositionID={this.getEditingCompositionID} changeSelectedTab={this.changeSelectedTab} getContextMenu={this.getContextMenu}/>          
                </div>
            )
        }
        else if(this.state.selectedTab === 2)
        {
            if(this.props.editingCompositionInfo)
            {
            return(
                <div style={attributesArea}>
                    <div style={groupTitle}>
                        區塊主要屬性
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>區塊ID</div>
                        <div style={this.props.editingCompositionInfo ? rowValue :rowValueDisbale}>{this.props.editingCompositionInfo ? this.props.editingCompositionInfo.conID : "未選取區塊"}</div>
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>區塊種類</div>
                        <div style={this.props.editingCompositionInfo ? rowValue :rowValueDisbale}>{this.props.editingCompositionInfo ? this.props.editingCompositionInfo.type : "未選取區塊"}</div>
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>區塊名稱</div>
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='text' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.title : "未選取區塊"} onChange={this.changeTitle}/>
                    </div>
                    <div style={groupTitle}>
                        區塊邊線
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>邊線型式</div> 
                        <select value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.commonAttributes.border.style : "none"} className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} onChange={this.changeBorderStyle}>
                            <option value="none">無邊界</option>
                            <option value="dotted">......</option>
                            <option value="dashed">-----</option>
                            <option value="solid">&#9473;&#9473;</option>
                            <option value="double">&#9552;&#9552;</option>
                            <option value="groove">立體框I</option>
                            <option value="ridge">立體框II</option>
                            <option value="inset">鑲崁I</option>
                            <option value="inset">鑲崁II</option>
                        </select>
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>邊線寬度</div>
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.commonAttributes.border.width : "未選取區塊"} onChange={this.changeBorderWidth}/>
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>邊線顏色</div>
                        <div style={rowValue}>
                            <ColorPickerCell style={this.props.editingCompositionInfo ? null : classWithDisable} color={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.commonAttributes.border.color : "#ffffff"} changeColor={this.changeBorderColor}/>
                        </div>
                    </div>
                    <div style={groupTitle}>
                        區塊大小
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>區塊寬度</div>
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.width : "未選取區塊"} onChange={this.changeWidth} />        
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>區塊高度</div>     
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.height : "未選取區塊"} onChange={this.changeHeight} />
                    </div>
                    <div style={groupTitle}>
                        區塊位置
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>X</div>
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.x : "未選取區塊"} onChange={this.changeX}/>       
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>Y</div>
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.y : "未選取區塊"} onChange={this.changeY}/>
                    </div>
                    <div style={rowArea}>
                        <div style={rowTitle}>Z</div>
                        <input className={"rowForm"} style={this.props.editingCompositionInfo ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo ? this.props.editingCompositionInfo.zIndex : "未選取區塊"} onChange={this.changeZ} min={0} max={100}/>
                    </div>
                    {this.detectCompositionType(this.props.editingCompositionInfo.type)}
                </div>
            )
            }
            else
            {
                return "尚未建立或尚未選取編輯區塊"
            }
        }
    }

    detectCompositionType=(type)=>{
        //console.log("detectCompositionType")
        //console.log(type)
        switch(type){
            case "image":
                return this.createImageFieldsArea()
            case "text":
                return this.createTextFieldsArea()
            default:
                return null
        }
    }

    returnFontFamilyOptionStyle=(family)=>{
        let style = {
            fontFamily:null
        }
        
        if(family === "none")
        {
            style.fontFamily = ""
        }
        else
        {
            style.fontFamily = family
        }
        return style
    }

    createImageFieldsArea=()=>{
        console.log("createImageFieldsArea")

        let groupTitle = {
            textAlign:"center",
            fontFamily: "Microsoft JhengHei",
            border:"1px solid black",
        }

        let rowArea = {
            display: 'flex',
        }

        let rowTitle = {
            width:"40%",
            border:"1px solid black",
            fontFamily: "Microsoft JhengHei",
        }

        let classWithDisable = {
            pointerEvents:"none"
        }

        return (
            <div>
                <div style={groupTitle}>
                    影像資訊
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>對比</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.contrast : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"contrast")}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>色調</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.hue : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"hue")}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>亮度</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.brightness : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"brightness")}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>飽和度</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.saturate : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"saturate")}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>棕色調</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.sepia : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"sepia")}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>正負片</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.invert : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"invert")}/>
                 </div>
                <div style={rowArea}>
                    <div style={rowTitle}>模糊</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.blur : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"blur")}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>透明度</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.imageAttributes.imageUrl ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.imageAttributes.imageAdjust ? this.props.editingCompositionInfo.imageAttributes.imageAdjust.opacity : "尚未選取影像"} onChange={(e)=>this.changeImageAdjust(e,"opacity")}/>
                </div>
            </div>
        )
    }

    createTextFieldsArea=()=>{
        //console.log("createTextFieldsArea")
        let groupTitle = {
            textAlign:"center",
            fontFamily: "Microsoft JhengHei",
            border:"1px solid black",
        }
        let rowArea = {
            display: 'flex',
        }
        let rowTitle = {
            width:"40%",
            border:"1px solid black",
            fontFamily: "Microsoft JhengHei",
        }
        let classWithDisable = {
            pointerEvents:"none",
            color:"#c9c9c9"
        }

        let rowValue = {
            width:"60%",
            border:"1px solid black",
        }

        return (
            <div>
                <div style={groupTitle}>
                    文字區塊資訊
                </div>
                <div style={groupTitle}>
                    背景設定
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>背景顏色</div>
                    <div style={rowValue}>
                        <ColorPickerCell style={this.props.editingCompositionInfo.textAttributes.background ? null : classWithDisable} color={this.props.editingCompositionInfo.textAttributes.background ? this.props.editingCompositionInfo.textAttributes.background.color : "#ffffff"} changeColor={this.changeTextBackgroundColor}/>
                    </div>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>背景透明度</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.textAttributes.background ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.textAttributes.background ? this.props.editingCompositionInfo.textAttributes.background.opacity : 100} min={0} max={100} onChange={this.changeTextBackgroundOpacity}/>
                </div>
                <div style={groupTitle}>
                    字型設定
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>字型顏色</div>
                    <div style={rowValue}>
                        <ColorPickerCell style={this.props.editingCompositionInfo.textAttributes.font ? null : classWithDisable} color={this.props.editingCompositionInfo.textAttributes.font ? this.props.editingCompositionInfo.textAttributes.font.color : "#000000"} changeColor={this.changeTextFontColor}/>
                    </div>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>字型大小</div>
                    <input className={"rowForm"} style={this.props.editingCompositionInfo.textAttributes.font ? null : classWithDisable} type='number' value={this.props.editingCompositionInfo.textAttributes.font ? this.props.editingCompositionInfo.textAttributes.font.size : 12} min={0} max={200} onChange={this.changeTextFontSize}/>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>中文字型</div> 
                    <select value={this.props.editingCompositionInfo.textAttributes.font ? this.props.editingCompositionInfo.textAttributes.font.cFamily : "none"} className={"rowForm"} style={this.props.editingCompositionInfo.textAttributes.font ? null : classWithDisable} onChange={this.changeTextFontCFamily}>
                        <option value="none" style={this.returnFontFamilyOptionStyle("none")}>瀏覽器預設值</option>
                        <option value="Microsoft JhengHei" style={this.returnFontFamilyOptionStyle("Microsoft JhengHei")}>微軟正黑體</option>
                        <option value="DFKai-SB" style={this.returnFontFamilyOptionStyle("DFKai-SB")}>標楷體</option>
                        <option value="PMingLiU" style={this.returnFontFamilyOptionStyle("PMingLiU")}>新細明體</option>
                        <option value="MingLiU" style={this.returnFontFamilyOptionStyle("MingLiU")}>細明體</option>
                        <option value="FangSong" style={this.returnFontFamilyOptionStyle("FangSong")}>仿宋體</option>
                        <option value="SimHei" style={this.returnFontFamilyOptionStyle("SimHei")}>黑體</option>
                    </select>
                </div>
                <div style={rowArea}>
                    <div style={rowTitle}>英數字型</div> 
                    <select value={this.props.editingCompositionInfo.textAttributes.font ? this.props.editingCompositionInfo.textAttributes.font.eFamily : "none"} className={"rowForm"} style={this.props.editingCompositionInfo.textAttributes.font ? null : classWithDisable} onChange={this.changeTextFontEFamily}>
                        <option value="none" style={this.returnFontFamilyOptionStyle("FangSong")}>瀏覽器預設值</option>
                        <option value="Times New Roman" style={this.returnFontFamilyOptionStyle("Times New Roman")}>Times New Roman</option>
                        <option value="Arial" style={this.returnFontFamilyOptionStyle("Arial")}>Arial</option>
                        <option value="Arial Black" style={this.returnFontFamilyOptionStyle("Arial Black")}>Arial Black</option>
                        <option value="Lucida Sans Unicode" style={this.returnFontFamilyOptionStyle("Lucida Sans Unicode")}>Lucida Sans Unicode</option>
                        <option value="Courier New" style={this.returnFontFamilyOptionStyle("Courier New")}>Courier New</option>
                        <option value="Lucida Console" style={this.returnFontFamilyOptionStyle("Lucida Console")}>Lucida Console</option>
                    </select>
                </div>
            </div>
        )
    }

    render(){
        
        let CompositionContainerStyle ={
            width:this.state.divSize.width,
            height:this.state.divSize.height,
            position:'fixed',
            left:this.state.position.x,
            top:this.state.position.y,
            //zIndex:this.props.zIndex,
            backgroundColor:"white",
            border:'3px solid',
            borderColor:'black',
            boxSizing:'border-box',
            display: 'flex',
            flexDirection: 'column',
            zIndex:1300,
            userSelect:"none"
        }

        const extendFunctionAreaStyle = {
            width:'20px',
            height:'20px',
            position:'absolute',
            right:'0px',
            bottom:'0px',
            userSelect:'none',
            color:"black",
            cursor:'nw-resize'
        }

        const buffeArea = {
            width:"100%",
            height:"30px",
        }

        const headerStyle = {
            width:'100%',
            height:'25px',
            borderBottom:'1px solid',
            borderColor:'gray',
            backgroundColor:'#3680cf',
            display:'flex',
            paddingTop:'2px',
            paddingLeft:'2px',
            userSelect:'none',
            cursor:'move',
        }

        return(
            <div style={CompositionContainerStyle} ref={this.editFloatWindowRef}> 
                <div style={headerStyle} onMouseDown={this.headerMouseDown} onMouseUp={this.headerMouseUp}>
                    <div key={1} className={this.checkTabSelected(1)} onClick={()=>this.tabOnClick(1)}>總功能區</div>
                    <div key={2} className={this.checkTabSelected(2)} onClick={()=>this.tabOnClick(2)}>編輯區塊屬性</div>          
                </div>
                {this.createContainer()}
                <div style={buffeArea}/>
                <div style={extendFunctionAreaStyle} onMouseDown={this.extendAreaMouseDown} onMouseUp={this.extendAreaMouseUp} >
                    &#9499;
                </div> 
            </div>
        )
    }
}

export default withStyles(wStyles)(EditFloatWindow)